import {
  AccordionSummary as MuiAccordionSummary,
  Typography,
  Checkbox,
  useTheme,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { FormControlLabel } from 'Features/OperationalPlanner/WorkcentreModal/FormControlLabel/FormControlLabel.view'
import { AccordionSummaryProps } from './AccordionSummary.types'
import {
  isAllWorkcentresSelected,
  isSomeWorkCentresSelected,
  isAllProductCountsInSiteWorkCentersZero,
} from 'Features/OperationalPlanner/WorkcentreModal/WorkcentreModal.utils'

export const AccordionSummary = ({
  sourceSiteData,
  handleCheckboxChange,
  readOnly,
}: AccordionSummaryProps) => {
  const theme = useTheme()

  return (
    <MuiAccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls={sourceSiteData.siteLabel}
      sx={{
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        paddingRight: '4px',
        '& .MuiIconButton-edgeEnd': {
          marginRight: '0px',
        },
        '& .MuiAccordionSummary-content': {
          display: 'flex',
          alignItems: 'center',
          margin: '0px',
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
          margin: '0px !important',
          minHeight: '48px !important',
        },
      }}
    >
      {readOnly ? (
        <Typography>{sourceSiteData.siteLabel}</Typography>
      ) : (
        <FormControlLabel
          label={sourceSiteData.siteLabel}
          control={
            <Checkbox
              disabled={isAllProductCountsInSiteWorkCentersZero(
                sourceSiteData.siteWorkcentres
              )}
              color="primary"
              sx={{
                color: theme.palette.primary.main,
              }}
              checked={isAllWorkcentresSelected(sourceSiteData.siteWorkcentres)}
              indeterminate={isSomeWorkCentresSelected(
                sourceSiteData.siteWorkcentres
              )}
              onChange={(event) =>
                handleCheckboxChange(event, sourceSiteData.siteLabel)
              }
            />
          }
        />
      )}
    </MuiAccordionSummary>
  )
}
